import { CSSProperties, ExtractPropTypes, PropType } from 'vue'
import { ClassName, COMMON_PROPS, PlacementType } from '../common'
import { TRANSITION_DURATION } from '../constants'
import { pickProps } from '../utils'

export type PopupProps = ExtractPropTypes<typeof POPUP_PROPS>

export const POPUP_PROPS = {
  ...pickProps(COMMON_PROPS, ['lockScroll', 'teleport', 'lazyRender', 'round']),
  visible: Boolean,
  title: String,
  placement: {
    type: String as PropType<PlacementType>,
    default: 'center'
  },
  zIndex: {
    type: Number,
    default: undefined
  },
  duration: {
    type: [Number, String] as PropType<number | string | undefined>,
    default: TRANSITION_DURATION
  },
  closable: Boolean,

  /**
   * 是否支持全屏
   */
  scale: {
    type: Boolean,
    default: false
  },

  /**
   * 动画前缀
   */
  transitionPrefix: {
    type: String,
    default: undefined
  },
  transitionAppear: {
    type: Boolean,
    default: false
  },

  popupContainerClass: {
    type: [String, Array, Object] as PropType<ClassName>,
    default: undefined
  },
  popupClass: {
    type: [String, Array, Object] as PropType<ClassName>,
    default: undefined
  },
  popupHeaderClass: {
    type: [String, Array, Object] as PropType<ClassName>,
    default: undefined
  },
  popupBodyClass: {
    type: [String, Array, Object] as PropType<ClassName>,
    default: undefined
  },
  popupStyle: {
    type: Object as PropType<CSSProperties>,
    default: {}
  },

  overlay: {
    type: Boolean,
    default: true
  },
  overlayClass: String,
  overlayStyle: {
    type: Object as PropType<CSSProperties>,
    default: {}
  },
  closeOnOverlayClick: {
    type: Boolean,
    default: true
  }
}
